import React from "react";
import { FaBullseye, FaGraduationCap } from "react-icons/fa";
import { HiOutlineServerStack } from "react-icons/hi2";
import { HOME_HERO } from "../../config/constants";

const HIGHLIGHT_ICONS = {
  focus: FaBullseye,
  stack: HiOutlineServerStack,
  background: FaGraduationCap,
};

function HomeHighlights() {
  return (
    <div className="home-highlights">
      {HOME_HERO.highlights.map((item) => {
        const Icon = HIGHLIGHT_ICONS[item.id];

        return (
          <div key={item.id} className={`home-highlight-card home-highlight-card--${item.id}`}>
            <div className="home-highlight-icon-wrap">
              {Icon && <Icon aria-hidden="true" />}
            </div>

            <div className="home-highlight-body">
              <span className="home-highlight-label">{item.label}</span>

              {item.text && (
                <p className="home-highlight-text">{item.text}</p>
              )}

              {item.tags && (
                <div className="home-highlight-tags">
                  {item.tags.map((tag) => (
                    <span key={tag} className="home-highlight-tag">
                      {tag}
                    </span>
                  ))}
                </div>
              )}

              {item.lines && (
                <div className="home-highlight-lines">
                  {item.lines.map((line) => (
                    <p key={line} className="home-highlight-text">
                      {line}
                    </p>
                  ))}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export default HomeHighlights;
